<template>
  <b-link
    v-click-outside="onOutsideClick"
    :class="[variant, { 'text-center': bigIcon == true }, 'icon-link']"
    :href="to"
    :target="openInNewTab ? '_blank' : '_self'"
    :rel="openInNewTab ? 'noopener noreferrer' : ''"
    v-bind="{
      ...$attrs,
      title,
    }"
    @click="onClick"
  >
    <div :class="{ 'd-flex align-items-center space-x-1': !linkText }">
      <slot v-if="!svgIcon" name="icon">
        <i
          :class="[
            iconPrefix,
            iconName,
            {
              'fa-2x big-icon mr-0': bigIcon,
              'mr-2': linkText,
            },
          ]"
        ></i>
      </slot>
      <slot v-else name="svg-icon"></slot>
      <span :class="[{ 'big-text': bigIcon == true }]">
        <slot v-if="linkText" name="linkText">{{ linkText }}</slot>
        <slot></slot>
      </span>
      <i v-if="hasDropdown" :class="`${iconPrefix} fa-sm fa-caret-${dropdownOpen ? 'up' : 'down'}`"></i>
    </div>
  </b-link>
</template>

<script>
  import ClickOutside from 'vue-click-outside';

  export default {
    name: 'IconLink',

    props: {
      to: String,
      iconName: String,
      linkText: String,
      variant: String,
      bigIcon: Boolean,
      smallIcon: Boolean,
      svgIcon: Boolean,
      hasDropdown: Boolean,
      title: String,
      duotone: Boolean,
      openInNewTab: {
        type: Boolean,
        default: false,
      },
    },

    directives: {
      ClickOutside,
    },

    data: () => ({
      dropdownOpen: false,
    }),

    methods: {
      onClick($event) {
        this.$emit('click', $event);
        if (this.hasDropdown) {
          this.dropdownOpen = !this.dropdownOpen;
        }
      },

      onOutsideClick() {
        this.dropdownOpen = false;
      },
    },

    computed: {
      iconPrefix() {
        return this.duotone ? 'fa-duotone' : 'fa';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-link {
    display: inline-block;
    white-space: nowrap;
    transition: none;
    color: var(--gray-900);

    &.delete {
      color: var(--danger);

      &:hover,
      &:focus {
        color: darkenHsl(danger, 7);
      }

      &:active {
        color: darkenHsl(danger, 13);
      }
    }

    &:hover {
      color: var(--gray-700);
      text-decoration: none;
    }

    .big-icon {
      display: block;
    }

    .big-text {
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
</style>
